<template>
    <v-form
        ref="form"
        lazy-validation
        @submit.prevent="resetPasswordRequest"
    >
        <v-card-title v-if="!noTitle" class="title">
            {{ 'Reset Password' | translation }}
        </v-card-title>

        <v-card-text>
            <v-text-field
                :label="$language.translate('E-Mail Adresse')"
                v-model="login"
                :rules="[rules.required, rules.email]"
                required
                :error-messages="errors"
                @change="errors = []"
                :success-messages="successMessages"
                :disabled="loading"
                autofocus
            ></v-text-field>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                type="submit"
                :loading="loading"
            >
                {{ 'reset Password' | translation }}
            </v-btn>
        </v-card-actions>

        <div class="text-xs-right pb-2 px-2">
            <a href="#" @click.prevent="$emit('hide')">
                {{ 'To login form' | translation }}
            </a>
        </div>
    </v-form>
</template>

<script>
    import Vue from 'vue';
    import {mapActions} from 'vuex';
    import module from '../store/login';

    const moduleName = 'Login';

    if (!Vue.$store.state[moduleName]) {
        Vue.$store.registerModule(moduleName, module);
    }

    export default {
        name: 'ResetPasswordRequestForm',
        props: {
            noTitle: Boolean,
        },
        data(){
            return {
                login: null,
                loading: false,
                errors: [],
                successMessages: [],
                rules: {
                    required: value => !!value || this.$language.translate('Dieses Feld wird benötigt und darf nicht leer sein.'),
                    length: value => (value ? (value.length >= 7 || this.$language.translate('Das Passwort muss mindestens 7 Zeichen haben.')) : ''),
                    email: value => /.+@.+/.test(value) || this.$language.translate('Bitte geben sie eine gültige Email-Adresse ein.'),
                },
            };
        },
        methods: {
            ...mapActions(moduleName, {
                resetPasswordRequestAction: 'resetPasswordRequest',
            }),
            resetErrors(field) {
                if (field && this.errors.hasOwnProperty(field)) {
                    delete this.errors[field];
                }
            },
            resetPasswordRequest() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    this.resetPasswordRequestAction({
                        login: this.login,
                    }).then(result => {
                        if (result) {
                            this.successMessages = [this.$language.translate('Wir haben eine E-Mail zum Zurücksetzen des Passworts gesendet.')];
                        } else {
                            this.errors = this.$language.translate('Something went wrong. Please reload the page and try again.');
                        }

                        this.loading = false;
                    }).catch(e => {
                        if (e.graphQLErrors && Array.isArray(e.graphQLErrors)) {
                            let errorMessages = e.graphQLErrors[0].message;
                            if (errorMessages) {
                                if (errorMessages.login) {
                                    this.errors = [errorMessages.login];
                                } else if (errorMessages.general) {
                                    this.errors = [errorMessages.general];
                                }
                            }
                        }

                        if (!this.errors.length) {
                            this.errors = [this.language.translate('Something went wrong. Please reload the page and try again.')];
                        }

                        this.loading = false;
                    });
                }
            },
        },
    };
</script>